import { MutableRefObject, useEffect, useRef } from 'react';
import { Formik, Form, FormikHelpers, FormikValues } from 'formik';
import cx from 'classnames';
import { Button, Textarea } from '@intellecteu/common-ui';
import { useNotifications } from 'app/utils/hooks';
import { useCommandHistory, useExecuteCommand } from 'data';
import { ui } from 'ui/styles';
import { Field } from '../ui/form/field';

import s from './styles.module.scss';

interface CommandProps {
  name: string;
  disabled?: boolean;
  renderCounterRef?: MutableRefObject<number>;
  callbackOnRender?: () => void;
  isFirstTab?: boolean;
}

export const Command = ({ name, disabled, renderCounterRef, callbackOnRender, isFirstTab }: CommandProps) => {
  const { showSuccessMessage } = useNotifications();
  const { data } = useCommandHistory(name);
  const hiddenRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (callbackOnRender) callbackOnRender();
  }, []);

  useEffect(() => {
    if (hiddenRef.current && (!isFirstTab || (renderCounterRef && renderCounterRef?.current > 1))) {
      hiddenRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [data?.length, renderCounterRef?.current, isFirstTab]);

  const { mutate: executeCommand, isLoading } = useExecuteCommand(name, {
    onSuccess: () => {
      showSuccessMessage('Command was executed', {
        autoClose: 1000,
      });
    },
  });
  const onSubmit = async (values: { script: string }, { resetForm }: FormikHelpers<FormikValues>) => {
    await executeCommand({ script: values.script });
    resetForm();
  };

  return (
    <div className={cx(ui.section, s.container)}>
      <Formik
        initialValues={{
          script: '',
        }}
        onSubmit={onSubmit}
      >
        {({ values }) => {
          return (
            <Form className={s.command}>
              <Field
                className={cx(ui.containerFormField, s.commandField)}
                component={Textarea}
                placeholder="Enter your command"
                id="script"
                name="script"
                rows={5}
              />
              <Button type="submit" isLoading={isLoading} disabled={values.script.trim().length <= 0 || disabled}>
                <span>Execute</span>
              </Button>
            </Form>
          );
        }}
      </Formik>
      {data && (
        <ul className={s.commandHistory}>
          {data?.map((item, i) => (
            <li key={`${i}`} className={s.commandHistoryItem}>
              <pre className={s.commandHistoryItemPre}>{item}</pre>
            </li>
          ))}
          <div ref={hiddenRef} />
        </ul>
      )}
    </div>
  );
};
